import { render, staticRenderFns } from "./ToolsRegistrationForm.vue?vue&type=template&id=87cf7ed2&scoped=true&"
import script from "./ToolsRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ToolsRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./ToolsRegistrationForm.vue?vue&type=style&index=0&id=87cf7ed2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cf7ed2",
  null
  
)

export default component.exports